import styled from 'styled-components';
import { styled as styledTabTab } from 'react-tabtab';

const {
    TabListStyle, TabStyle, PanelStyle, ActionButtonStyle,
} = styledTabTab;

export const TabList = styled(TabListStyle)`
    margin-top: 10px;
    background-color: rgba(30,30,30,0.9);
    padding: 0 10px;
    display: block;
    text-align: center;
`;

export const Tab = styled(TabStyle)`
    list-style-type: none;
    display: inline-block;
    margin-right: 5px;
    border: 2px solid #e7e7e7;
    padding: 5px;
    background-color: #fff;
    ${props => (props.active
        ? `
        border-color: #2175bc;
        background-color: #2175bc;
        color: #fff;
        &:hover {
            color: #fff;
        }
        `
        : null)}
`;

export const ActionButton = styled(ActionButtonStyle)`
`;

export const Panel = styled(PanelStyle)`
    background-color: rgba(30,30,30,0.9);
    color: white;
    padding: 0;
`;

